import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    list: [],
    category: [],
    filter: {
      category: [],
      word: ''
    },
    sepPage: ''
  },
  mutations: {
    categoryIds: function (state, arr) {
      let result = []
      const ids = function (arr) {
        arr.forEach(function (x) {
          if (x.children && x.children.length) {
            ids(x.children)
          }
          return result.push(x.id)
        })
        return result
      }
      state.filter.category = ids(arr)
    },
    setSepPage (state, sepId) {
      // console.log(sepId)
      state.sepPage = sepId
    },
    setFilter (state, data) {
      state.filter[data.key] = data.value
    }
  },
  actions: {
    async getSepList ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-page-manage',
          func: 'get-all-pages',
          id: 'a.sep'
        })
        state.list = res.data.message.map(x => x.pageData)
        return res.data.message
      } catch (ex) {
        // console.error('error:', ex)
        return false
      }
    },
    async getSepCategory ({ state, commit }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: 'a.sep',
          file: 'category/list.json'
        })
        const category = res.data.message
        state.category = category
        commit('categoryIds', category)
        return res.data.message
      } catch (ex) {
        // console.error('error:', ex)
        return false
      }
    }
  },
  getters: {
    sepList: state => state.list,
    sepCategory: state => state.category,
    sepPage: state => state.sepPage,
    filter: state => state.filter
  }
}
